import settingHTTP from "./settingHTTP";

const Dashboard = {
  
  async getDashboardIdea() {
    try {
      const res = await settingHTTP.get("/Idea/CuadroMandoUsuario");
      if(res.status===200){
        return res.data;
      }  
    } catch (e) {
      //window.location.href = "/error-pages/error-500";
      if(e.request.status === 404){
        alert("error 404")
      }
      else{
        //alert("Error de Servidor, recargar página")
      }
      //return e;
    }
  },
  async getIdeaRecientes(data) {
    try {
      const res = await settingHTTP.post("/Idea/Todo",data);
      if(res.status===200){
        return res.data;
      }  
    } catch (e) {
      //window.location.href = "/error-pages/error-500";
      if(e.request.status === 404){
        alert("error 404")
      }
      else{
        //alert("Error de Servidor, recargar página")
      }
      //return e;
    }
  },
  async getPerfil() {
    try {
      const res = await settingHTTP.get("/Persona/Perfil");
      if(res.status===200){
        return res.data;
      } 
      
    } catch (e) {
      //window.location.href = "/error-pages/error-500";
      if(e.request.status=== 404){
        alert("error 404")
      }
      else{
        //alert("Error de Servidor, recargar página")
      }
      //return e;
    }
  },
  async createPerfil(data) {
    try {
      const res = await settingHTTP.put("/Persona", data);
      return res;
    } catch (e) {
      console.error("Error al crear", e.message);
      return e;
    }
  },
  
};

export default Dashboard;
